
import React from 'react';
import Navbar from '../components/Navbar';
import styled from "styled-components";
import Announcement from '../components/Announcement';
import UhaulSlider from '../components/UhaulSlider';
import Footer from '../components/Footer';
import Block from '../components/Block';
import { mobile } from '../responsive';

const Container = styled.div`
`;
const Title = styled.h1`
    margin: 20px;
    font-size: 40px;
`;
const SubHeader = styled.h1`
    margin: 20px;
    margin-top: -90px;
    ${mobile({ display: "none" })}
`;

const Uhaul = () => {
  return (
    <Container>
        <Navbar/>
        <Announcement/>
        <Title>U-Haul Rental Information:</Title>
        <UhaulSlider/>
        <SubHeader>General U-Haul Information:</SubHeader>
        <Block/>
        <Footer/>
    </Container>
  )
}

export default Uhaul